import keys from 'lodash/keys';
import pick from 'lodash/pick';

import { createServiceAction } from '../util/actionHelper.js';
import { apiConfig } from '../configs/apiConfig.js';
import { postRequest, displayMessage } from '../util/index.js';
import { getHTTPStatusValidationMessage, getServerValidationMessage } from '../services/serverValidations.js';

import { put, takeEvery, call } from 'redux-saga/effects';

function* listener(serviceType, action) {
  try {
    const model = {
      trfId: null,
      location: null,
      quantity: null,
      leftFacility: null,
      factories: null,
      isAffectedKidProduct: null,
      nextStep: null,
      attachment:null,
      materialWorth:null,
      futureProduction:null
    };
    const path = {
      history: null
    };
    const result = pick(action.data, keys(model));
    const routes = pick(action.data, keys(path));
    const data = { ...result };
    const infoPopDuration = 1000;
    if(action.data.PDCA === "Yes" || action.data.futureProduction === "No" ){// hide success message for partial save
      yield call(displayMessage, 'info', 'Submitting your data..', infoPopDuration);
    }
    yield put(createServiceAction(serviceType, 'loading')());
    const res = yield call(postRequest, apiConfig.qrfData.endPointUrl, data);
    // Display HTTP status error message
    const statusErrorMessage = yield call(getHTTPStatusValidationMessage, res, infoPopDuration);
    if(!statusErrorMessage){
      const response = yield res.json();
      // Display server error message
      const serverErrorMessage = yield call(getServerValidationMessage, response, infoPopDuration);
      if (!serverErrorMessage && response.errorCode === 0) {
        yield put(createServiceAction(serviceType, 'success')(response));
        const message = `${response.message}`;
        // Display success message
        if(action.data.PDCA === "Yes" || action.data.futureProduction === "No"){ // hide success message for for partial save
        yield call(displayMessage, 'success', message, 5000);
        }
        if(response.data && response.data && (action.data.futureProduction === 'Yes' && action.data.PDCA === "Yes")){
          const history = routes.history;
          const qrfId = response.data.qrfId;
          const frfData = {
            ...action.data,qrfId
          };
          yield put(createServiceAction('frfSubmit','submitted')(frfData, history)) 
        }
        if(action.data.PDCA === "No" && action.data.futureProduction === "Yes"){
          yield put(createServiceAction('trfDetails', 'requested')(result.trfId));
        }
        if(action.data.proposedCorrectiveAction === 'Yes' && action.data.futureProduction === "Yes"){
          routes.history.push('/trf',{ rslId: result.RSLNo , isRetest: 'Yes',trfId: result.trfId, isPartialEdit: true,preLoadMaterial:true});
        }
        if(action.data.futureProduction === "No"){
          routes.history.push(`/download-qrf/`, { trfId: result.trfId });
        }
      }
    }
  } catch (e) {
    yield put(createServiceAction(serviceType, 'error')(e));
  }
}

function* qrfSagas() {
  const serviceType = 'qrfSubmit';
  yield takeEvery(createServiceAction(serviceType, 'submitted').type, listener, serviceType);
}

export default qrfSagas;
